import { Plus, X } from "lucide-react";

export default function DebtorEditor({ borclular = [], onChange }) {
  const add = () => onChange([...borclular, { ad: "", tc: "" }]);
  const upd = (i, k, v) => onChange(borclular.map((b, idx) => (idx === i ? { ...b, [k]: v } : b)));
  const rem = (i) => onChange(borclular.filter((_, idx) => idx !== i));
  return (
    <div data-testid="debtor-editor">
      <div className="flex items-center justify-between mb-1.5">
        <label className="kicker">EK BORÇLULAR ({borclular.length})</label>
        <button type="button" onClick={add} data-testid="debtor-add" className="inline-flex items-center gap-1 text-xs font-semibold text-[#B8933F] hover:underline"><Plus className="w-3.5 h-3.5" /> Borçlu Ekle</button>
      </div>
      {borclular.length === 0 ? (
        <div className="text-xs text-[#8C8377]">Ek borçlu yok. Kefil / 2. (veya daha fazla) borçlu için "Borçlu Ekle".</div>
      ) : (
        <div className="space-y-2">
          {borclular.map((b, i) => (
            <div key={i} className="flex gap-2 items-center" data-testid={`debtor-row-${i}`}>
              <span className="text-xs text-[#8C8377] w-4 shrink-0">{i + 1}.</span>
              <input value={b.ad || ""} onChange={(e) => upd(i, "ad", e.target.value)} placeholder="Ad Soyad" data-testid={`debtor-ad-${i}`} className="flex-1 px-2 py-1.5 border border-[#E7DECC] rounded-sm text-sm focus:outline-none focus:border-[#B8933F]" />
              <input value={b.tc || ""} onChange={(e) => upd(i, "tc", e.target.value.replace(/\D/g, "").slice(0, 11))} placeholder="TC No" inputMode="numeric" data-testid={`debtor-tc-${i}`} className="w-36 px-2 py-1.5 border border-[#E7DECC] rounded-sm text-sm tabular-nums focus:outline-none focus:border-[#B8933F]" />
              <button type="button" onClick={() => rem(i)} data-testid={`debtor-del-${i}`} className="p-1 text-[#8C8377] hover:text-[#A63A3A]"><X className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
